<div class="batch-config-container">

  <form [formGroup]="batchConfigForm" data-tour="firma-step1-root" class="config-form">

    <!-- ==================================================== -->
    <!-- ÚNICA SECCIÓN -->
    <!-- ==================================================== -->

    <section >

      <!-- ================================================== -->
      <!-- INFORMACIÓN GENERAL -->
      <!-- ================================================== -->

      <div class="section-header">

        <div class="section-heading">
          <h3 class="section-title">
            Información general
          </h3>
        </div>

        <!-- AYUDA -->
        <div class="section-actions">

          <button type="button" class="help-btn" (click)="onHelp(true)" aria-label="Ayuda" title="Ver ayuda">

            <i class="fa fa-info"></i>

          </button>

        </div>

      </div>


      <!-- ================================================== -->
      <!-- TÍTULO -->
      <!-- ================================================== -->

      <div class="row">

        <div class="col-12 col-lg-12" data-tour="firma-titulo">

          <div class="field-group">

            <label for="title" class="form-label">

              Título
              <span class="required-mark">*</span>

            </label>

            <input type="text" id="title" class="form-control" formControlName="titulo"
              placeholder="Ej. Documento agosto 2026" [class.is-invalid]="
                batchConfigForm.get('titulo')?.touched &&
                batchConfigForm.get('titulo')?.invalid
              " />


            <!-- REQUIRED -->

            <div class="field-error" *ngIf="
                batchConfigForm.get('titulo')?.touched &&
                batchConfigForm.get('titulo')?.errors?.['required']
              ">

              <i class="fa-solid fa-circle-exclamation"></i>

              <span>
                El título es requerido.
              </span>

            </div>


            <!-- MIN LENGTH -->

            <div class="field-error" *ngIf="
                batchConfigForm.get('titulo')?.touched &&
                batchConfigForm.get('titulo')?.errors?.['minlength']
              ">

              <i class="fa-solid fa-circle-exclamation"></i>

              <span>
                El título debe tener al menos 3 caracteres.
              </span>

            </div>

          </div>

        </div>

      </div>


      <!-- ================================================== -->
      <!-- CONFIGURACIÓN DEL SOBRE -->
      <!-- ================================================== -->

      <div class="section-header configuration-header">

        <div class="section-heading">

          <h3 class="section-title">
            Configuración del sobre
          </h3>

        </div>

      </div>


      <!-- ================================================== -->
      <!-- OPCIONES -->
      <!-- ================================================== -->

      <div class="configuration-options">

        <!-- ================================================= -->
        <!-- AGRUPAR DOCUMENTOS -->
        <!-- ================================================= -->

        <div class="configuration-row" [class.has-complement]="true">


          <!-- =============================================== -->
          <!-- AGRUPAR -->
          <!-- =============================================== -->

          <div class="config-option" data-tour="firma-es-grupo" [class.is-enabled]="batchConfigForm.get('es_grupo')?.value">

            <div class="config-option-content">

              <div class="config-option-icon">
                <i class="fa-solid fa-layer-group"></i>
              </div>


              <div class="config-option-info">

                <span class="config-option-title">
                  Firma por grupo
                </span>

                <span class="config-option-description">
                  Procesa los documentos como un único grupo.
                </span>

              </div>

            </div>


            <label class="toggle-switch">

              <input id="es_grupo" type="checkbox" formControlName="es_grupo" />

              <span class="toggle-slider"></span>

            </label>

          </div>


          <!-- =============================================== -->
          <!-- COMPLEMENTO: RENOMBRAR -->
          <!-- =============================================== -->

          <div class="config-option config-complement" data-tour="renombrar-documentos"
            [class.is-enabled]="batchConfigForm.get('renombrar_documentos')?.value"
            *ngIf="batchConfigForm.get('es_grupo')?.value">

            <div class="config-option-content">

              <div class="config-option-icon">
                <i class="fa-solid fa-file-pen"></i>
              </div>


              <div class="config-option-info">

                <div class="option-title-row">

                  <span class="config-option-title">
                    Renombrar documentos
                  </span>

                  <span class="option-badge">
                    Grupo
                  </span>

                </div>


                <span class="config-option-description">
                  Permite asignar un nuevo nombre a los documentos del grupo.
                </span>

              </div>

            </div>


            <label class="toggle-switch">

              <input id="renombrar_documentos" type="checkbox" formControlName="renombrar_documentos" />

              <span class="toggle-slider"></span>

            </label>

          </div>

        </div>



        <!-- ================================================= -->
        <!-- FIRMA POR PLANTILLA -->
        <!-- ================================================= -->

        <div class="configuration-row" [class.has-complement]="true">


          <!-- =============================================== -->
          <!-- FIRMA POR PLANTILLA -->
          <!-- =============================================== -->

          <div class="config-option" data-tour="firma-por-plantilla"
            [class.is-enabled]="batchConfigForm.get('firma_por_plantilla')?.value">

            <div class="config-option-content">

              <div class="config-option-icon">
                <i class="fa-solid fa-file-circle-check"></i>
              </div>


              <div class="config-option-info">

                <span class="config-option-title">
                  Firma por plantilla
                </span>

                <span class="config-option-description">
                  Utiliza una plantilla predefinida para configurar la firma.
                </span>

              </div>

            </div>


            <label class="toggle-switch">

              <input id="firma_por_plantilla" type="checkbox" formControlName="firma_por_plantilla" />

              <span class="toggle-slider"></span>

            </label>

          </div>


          <!-- =============================================== -->
          <!-- COMPLEMENTO: SELECT PLANTILLA -->
          <!-- =============================================== -->

          <div class="config-complement template-complement" *ngIf="batchConfigForm.get('firma_por_plantilla')?.value">

            <div class="field-group">

              <label class="form-label">

                Plantilla

                <span class="required-mark">*</span>

              </label>


              <ng-select formControlName="id_plantilla" [items]="plantillas" bindLabel="nombre" bindValue="id"
                placeholder="Seleccione una plantilla" [searchable]="true" [clearable]="true">
              </ng-select>


              <div class="field-error" *ngIf="
            batchConfigForm.get('id_plantilla')?.touched &&
            batchConfigForm.get('id_plantilla')?.errors?.['required']
          ">

                <i class="fa-solid fa-circle-exclamation"></i>

                <span>
                  La plantilla es requerida.
                </span>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>

  </form>

</div>